export default "__VITE_ASSET__31277649__$_?nuxt_component=async&nuxt_component_name=SvgoFreebfg__"